import React from 'react';
import { AlertTriangle, ShieldAlert, Ban, Clock } from 'lucide-react';

export const SecurityAlertBanner = ({
  status,
  message,
  remainingAttempts,
  jailCountdown,
}) => {
  const formatTimer = (totalSeconds) => {
    if (!totalSeconds || totalSeconds <= 0) return '00:00';
    const mins = Math.floor(totalSeconds / 60);
    const secs = totalSeconds % 60;
    return `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
  };

  if (status === 'ERROR_403_JAIL') {
    return (
      <div 
        role="alert"
        aria-live="assertive"
        className="mt-4 p-3.5 rounded-xl bg-red-950/40 border border-red-500/60 text-red-200 shadow-[0_0_20px_rgba(239,68,68,0.3)] animate-pulse"
      >
        <div className="flex items-start space-x-3">
          <ShieldAlert className="w-5 h-5 text-red-400 mt-0.5 flex-shrink-0" />
          <div className="flex-1">
            <h4 className="text-xs font-mono font-bold uppercase tracking-wider text-red-300">
              [DEFENSE PROTOCOL // IP QUARANTINED]
            </h4>
            <p className="text-xs mt-1 text-red-200/90 leading-relaxed font-mono">
              Exceeded 5 consecutive failed login attempts. IP quarantined to protect server infrastructure.
            </p>
            <div className="mt-2.5 flex items-center justify-between p-2 rounded-lg bg-black/60 border border-red-500/30 font-mono text-xs">
              <span className="flex items-center space-x-1.5 text-red-400">
                <Clock className="w-3.5 h-3.5 animate-spin" />
                <span>Quarantine Unlocks In:</span>
              </span>
              <span className="font-bold text-red-300 tracking-wider text-sm">
                {formatTimer(jailCountdown)}
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (status === 'ERROR_401') {
    return (
      <div 
        role="alert"
        aria-live="polite"
        className="mt-4 p-3 rounded-xl bg-amber-950/30 border border-amber-500/40 text-amber-200"
      >
        <div className="flex items-center space-x-3">
          <AlertTriangle className="w-5 h-5 text-amber-400 flex-shrink-0" />
          <div className="flex-1">
            <div className="text-xs font-semibold">Access Denied: Invalid Credentials</div>
            {remainingAttempts !== null && remainingAttempts !== undefined && (
              <div className="text-[11px] font-mono text-amber-300/90 mt-0.5">
                Warning: {remainingAttempts}/5 attempts remaining before automated IP quarantine.
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  if (status === 'QUARANTINE_EXPIRED') {
    return (
      <div 
        role="alert"
        className="mt-4 p-3 rounded-xl bg-emerald-950/40 border border-emerald-500/50 text-emerald-300 text-xs font-mono"
      >
        {message || 'Quarantine timer expired. Access restored.'}
      </div>
    );
  }

  if (status === 'ERROR_403_STATUS') {
    return (
      <div 
        role="alert"
        className="mt-4 p-3 rounded-xl bg-purple-950/30 border border-purple-500/40 text-purple-200"
      >
        <div className="flex items-center space-x-3">
          <Ban className="w-5 h-5 text-purple-400 flex-shrink-0" />
          <div className="flex-1">
            <div className="text-xs font-semibold">Account Restricted</div>
            <div className="text-[11px] font-mono text-purple-300 mt-0.5">{message}</div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div 
      role="alert"
      className="mt-4 p-3 rounded-xl bg-red-950/30 border border-red-500/40 text-red-300 text-xs font-mono"
    >
      {message || 'Authentication failed. Please verify credentials.'}
    </div>
  );
};

export default SecurityAlertBanner;
